import React from 'react';
import Helmet from 'react-helmet';
import { Fade } from 'react-reveal';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import config from '../../config/SiteConfig';
import SEO from '../components/SEO/SEO';
import Footer from '../components/Footer/Footer';
import Container from '../components/Container/Container';
import Hero from '../components/Hero/hero';
import styles from './page.module.scss';

const Page = () => {
  return (
    <div className="container project-container">
      <Helmet title={`${config.siteTitle}`} />
      <div className={styles.headerWrapper}>
        <Hero cover="../pictures/varna/hero.jpg" title="Varna Library" link="#content" />
      </div>
      <div style={{ display: `flex`, flexDirection: `row` }}>
        <p id="content" style={{ width: `30%`, marginLeft: `18%` }}>
          The aim is to design a new public building typol- ogy for the interactive city life of 21C. Our driving
          motivation is architecturally guided structural op- timization in order to achieve interaction between façade,
          columns and slabs. Vertical force flow of
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          the building is expressed by the wooden façade which acts as an external supportive structure of the building.
          The horizontal flow inside each slab corresponds to this.
        </p>
      </div>
      <img src="../pictures/varna/first.jpg" alt="Stairways inside the library"/>
      <img src="../pictures/varna/diagram.png" alt="Diagrams explaining the library" />
      <div style={{ display: `flex`, flexDirection: `row` }}>
        <p id="content" style={{ width: `30%`, marginLeft: `18%` }}>
          The wooden structure formed around the build- ing, act as a louver system navigating a comfortable light into
          the library. It also co-relate with the horizontal structural elements forming a functionally articulated
          space.
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          We use new and innovative simulation technology in order to engineer strong, thin and light weight wooden
          composite which is capable to withstand all necessary load cases.
        </p>
      </div>
      <img src="../pictures/varna/second.jpg" alt="Interior of the library" />
      <Footer />
    </div>
  );
}
export default Page;




// WEBPACK FOOTER //
// ./src/pages/varna.jsx